/**
 * Invite Permissions
 */
import { TABLE_TYPES } from "@/helpers/constants";

export default {
  methods: {
    /**
     * Check that user can accept video call invites
     * @param user {Object}
     * @return {function(): boolean}
     */
    canUserAcceptVideoCallInvites(user) {
      return this.$store.getters["users/canUserAcceptVideoCallInvites"](user);
    },

    /**
     * Check that user can accept table movement invites
     * @param table {Object} DigitalEventTable
     */
    canUserAcceptTableMovementInvites(table) {
      return this.$store.getters["invites/canUserAcceptTableMovementInvites"](table);
    },

    /**
     * Check that user can send table movement invites
     * @param user {Object} User
     */
    canUserSendTableMovementInvites(user) {
      let table = this.$store.getters["tables/tableByUser"](user);
      let userTable = this.$store.getters["tables/userTable"];
      return (
        userTable.TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY &&
        table &&
        userTable.uuid !== table.uuid &&
        userTable.SEND_USER_MOVEMENT_INVITES &&
        this.$store.getters["invites/canUserAcceptTableMovementInvites"](table)
      );
    }
  }
};
